module.exports = __webpack_public_path__ + "static/media/display-4.4f33f8ea.png";